export const scrollToSection = (href) => {
  setTimeout(() => {
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  }, 100);
};
